// ヘッダー/フッターのエリア版セレクタ（総合版⇔都道府県版の切替）
// GETリンク方式: 現在パスの先頭セグメント（エリア接頭辞）だけを差し替えて遷移する。
//   - エリア → 別エリア: 同じページに留まる（クエリ文字列も維持。例: /iwate/list?type=x → /hiroshima/list?type=x）
//   - 総合版・エリア非依存ページ → エリア: そのエリアのTOPへ遷移（切替元に対応する接頭辞付きページが無いため）
//   - エリア → 総合版: 総合TOP（/）へ遷移
const versionSelect = () => {
    document.querySelectorAll(".js-version-select").forEach((select) => {
        select.addEventListener("change", () => {
            const option = select.options[select.selectedIndex];
            const targetArea = option?.dataset.area || null; // 総合版のoptionにはdata-areaが無い
            const currentArea = select.dataset.currentArea || null;
            if (select.hasAttribute('data-campaign-select')) {
                window.location.href = option.value;
                return;
            }

            // エリア→エリアの切替時のみ、現在のパス・クエリ文字列を維持して先頭セグメントを差し替える
            if (currentArea && targetArea) {
                const segments = (select.dataset.currentPath || "").split("/");
                segments[0] = targetArea;
                // 本番は /bunjo 配下で配信される。ここは route() を通らず自前でパスを組むため、
                // Blade から渡した接頭辞（SITE_URL_PREFIX）を自分で足す必要がある
                const prefix = select.dataset.urlPrefix || "";
                window.location.href = prefix + "/" + segments.join("/") + window.location.search;
                return;
            }

            // それ以外（総合版⇔エリア、またはエリア非依存ページからの切替）は各版のTOPへ
            window.location.href = option.value;
        });
    });
};
export default versionSelect;
